import { gql } from '@apollo/client/core'
import { useMutation } from '/@/core/graphql'

export type EventType =
  | 'HELP_HUB_CLICKED'
  | 'TEMPLATE_ASSISTANT_DESIGN_CONCEPTING_CLICKED'
  | 'TEMPLATE_ASSISTANT_SPATIAL_PLANNING_CLICKED'

export interface EventInput {
  eventType: EventType
}

export function useInternalSignalApi() {
  const { mutate: trackEvent } = useMutation(gql`
    mutation trackEvent($input: EventInput!) {
      tracking {
        trackEvent(input: $input) {
          status
        }
      }
    }
  `)

  return {
    async trackEvent(input: EventInput) {
      await trackEvent({ input })
    },
  }
}
